import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { EMPTY, of, switchMap } from 'rxjs';
import { map, take } from 'rxjs/operators';

import {
    GetProductPreviewDocument,
    GetProductPreviewQuery,
} from '../../common/gql/graphql';
import { DataService } from '../../../core/providers/data/data.service';

export const productDetailResolver: ResolveFn<GetProductPreviewQuery['product']> = (route) => {
    const router = inject(Router);
    return inject(DataService)
        .query(
            GetProductPreviewDocument,
            {
                slug: route.paramMap.get('slug') || '',
            },
            { ssr: true },
        )
        .pipe(
            map((data) => data.product),
            take(1),
            switchMap((result) => {
                if (!result) {
                    router.navigate(['/p/404/', route.paramMap.get('slug')]);
                    return EMPTY;
                } else {
                    return of(result);
                }
            }),
        );
};
